import React, { useState } from 'react';
import Modal from "./Modal";

const MainBlockBotBtns = (props) => {

    const [btn1Hover, setBtn1Hover] = useState(false)
    const [btn2Hover, setBtn2Hover] = useState(false)

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <div className='flex items-center flex-wrap gap-1'>
                <a href="#services">
                    <button className={`flex items-center gap-1 rounded-[30px] text-[16px] sm:text-[20px] py-[12px] sm:px[24px] px-[20px] transition-colors duration-300`}
                        onMouseEnter={() => setBtn1Hover(true)}
                        onMouseLeave={() => setBtn1Hover(false)}
                        style={{
                            color: btn1Hover ? props.data.BotBtns[0].colorHover : props.data.BotBtns[0].color,
                            backgroundColor: btn1Hover ? props.data.BotBtns[0].bgHover : props.data.BotBtns[0].bg
                        }}>
                        {props.data.BotBtns[0].text}
                        <svg
                            style={{
                                fill: btn1Hover ? props.data.colors[0].colorWhite : props.data.colors[0].colorRed
                            }}
                            className="transition-colors duration-300 fill-[#C3372E] group-hover:fill-white"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.75811 7.24219L8.75811 5.24219H18.2434V14.7275H16.2434V8.6564L7.3439 17.5559L5.92969 16.1417L14.8292 7.24219H8.75811Z" />
                        </svg>
                    </button>
                </a>


                <button onClick={handleOpenModal} className={`flex items-center gap-1 text-[16px] sm:text-[20px] py-[12px] sm:px[24px] px-[20px] rounded-[30px] border-solid border-[1px] duration-300 bg-transparent group transition-colors`}
                    onMouseEnter={() => setBtn2Hover(true)}
                    onMouseLeave={() => setBtn2Hover(false)}
                    style={{
                        color: btn2Hover ? props.data.BotBtns[1].colorHover : props.data.BotBtns[1].color,
                        backgroundColor: btn2Hover ? props.data.BotBtns[1].bgHover : ''
                    }}>
                    {props.data.BotBtns[1].text}
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className='fill-white group-hover:fill-[#1F2225] transition-colors duration-300'>
                        <path d="M8.75811 7.24219L8.75811 5.24219H18.2434V14.7275H16.2434V8.6564L7.3439 17.5559L5.92969 16.1417L14.8292 7.24219H8.75811Z" />
                    </svg>
                </button>
            </div>
            <Modal isOpen={isModalOpen} onClose={handleCloseModal} />
        </>
    )

}

export default MainBlockBotBtns;